import { render, staticRenderFns } from "./Func31Historico.vue?vue&type=template&id=478932bd"
import script from "./Func31Historico.vue?vue&type=script&lang=js"
export * from "./Func31Historico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports